import { axiosRubyClient as api } from '@/util/axios/axiosClient';

export type JobHoldLogAction = 'created' | 'released' | 'expired' | 'claimed';

export type JobHoldLog = {
  id: number;
  worker_id: number;
  job_id: number;
  job_title: string | null;
  customer_name: string | null;
  action: JobHoldLogAction;
  source: string | null;
  hold_created_at: string | null;
  age_seconds: number | null;
  created_at: string;
};

export type Pagination = {
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
};

export type JobHoldLogListResponse = {
  success: boolean;
  data: JobHoldLog[];
  pagination: Pagination;
};

export async function fetchWorkerJobHoldLogs(
  workerId: number,
  params: { page?: number; per_page?: number } = {},
): Promise<JobHoldLogListResponse> {
  const res = await api.get<JobHoldLogListResponse>(
    `/api/admin/workers/${workerId}/job_hold_logs`,
    { params },
  );
  return res.data;
}
